<template >
  <section class="section"  v-if="(this.$store.state.auth.user.role == 0 || this.$store.state.auth.user.role == 1)">
    <title-bar>
      Users
      <span class="number-of-user" v-if="totalUsers">({{ totalUsers }})</span>
      <CreateNewUserModal slot="button" class="level-item" />
      <div class="level-item action" slot="button">
        <router-link to="/" class="button is-primary" slot="button">Dashboard</router-link>
      </div>
    </title-bar>

    <!-- <b-field position="is-centered">
      <b-input v-model="searchTerm" placeholder="Search..." type="search" icon="magnify"></b-input>
      <p class="control">
        <button class="button is-info">Search</button>
      </p>
    </b-field>-->
    <!-- <div id="autocomplete" class="autocomplete">
      <input
        v-model="searchTerm"
        @input="searchUpdated"
        class="autocomplete-input"
        placeholder="Search for Users"
        aria-label="Search for Users"
      />
    </div> -->
    <!-- <notification class="is-primary">
      <div>
        <b-icon icon="buffer" custom-size="default"/>
        <b>Sorted and paginated table.</b>&nbsp;Based on Buefy's table.
      </div>
    </notification>-->
    <card-component class="has-table" title="Users" icon="account-multiple" :searchT='this.searchType'
      @roleChanged="roleUpdated($event)">
      <UsersTable v-if="!isLoading" :checkable="false" />

      <h4 v-else>Loading...</h4>
    </card-component>

    <hr />

    <!-- <notification class="is-primary">
      <div>
        <b-icon icon="buffer" custom-size="default" />
        <b>Tightly wrapped</b> &mdash; table header becomes a card header
      </div>
    </notification>

    <card-component class="has-table has-mobile-sort-spaced">
      <clients-table-sample data-url="/data-sources/clients.json" :checkable="true" />
    </card-component>

    <hr />-->

    <!-- <notification class="is-primary">
      <div>
        <b-icon icon="buffer" custom-size="default" />
        <b>Empty table.</b> When there's nothing to show
      </div>
    </notification>-->

    <!-- <card-component class="has-table">
      <clients-table-sample />
    </card-component>-->
  </section>
</template>

<script>
import Notification from '@/components/Notification';
import ClientsTableSample from '@/components/ClientsTableSample';
import CardComponent from '@/components/CardComponent';
import TitleBar from '@/components/TitleBar';
import UsersTable from '../components/Users/UsersTable';
import CreateNewUserModal from '../components/Users/CreateNewUserModal';
export default {
  data() {
    return {
      searchTerm: '',
      totalUsers: null,
      isLoading: false,
      searchType: '1',
    };
  },
  name: 'Tables',
  components: { TitleBar, CardComponent, UsersTable, CreateNewUserModal },
  mounted() {
    this.$store.commit('isNavBarVisible', true);
  },
  methods: {
    roleUpdated(value){
      this.searchType = value;
      this.searchUpdated();
    },
    searchUpdated() {
      this.isLoading = true;
      let filter = {};
      if (this.searchTerm.includes('=')) {
        var keyVal = this.searchTerm.split('=');

        filter[keyVal[0]] = keyVal[1];
      } else {
        filter = {
          searchTerm: this.searchTerm,
          limit: 10,
          role:this.searchType
        };
      }
      if(this.searchType == 99) delete filter.role;
      this.$store
        .dispatch('users/fetchUsers', {
          filter: filter,
        })
        .then(() => {
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$buefy.toast.open({
            message: `Error: ${err.message}`,
            type: 'is-danger',
          });
        });
    },
  },
  created() {
    this.searchUpdated();
    // this.$onSocket.on('onOnlineUserListUpdate', (res) => {
    //   console.log(res);
    // });
    this.totalUsers = this.$store.state.dashboard.dashboard.userCount;
  },
};
</script>

<style scoped lang="scss">
.is-title-bar {
  margin-bottom: 1rem;
}

#autocomplete {
  max-width: 400px;
  margin: 0 auto;
}

.autocomplete-input {
  margin-bottom: 13px;
}

.autocomplete-result-list {
  margin-bottom: 10px;
}

@media screen and (max-width: 768px) {
  .level-item:not(:last-child) {
    margin-bottom: 0;
    margin: 10px;
  }
}

.number-of-user {
  color: blue($color: #000000);
}
</style>
